<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="vx-row flex-grow ">
                <div style="display:inline-block" class="vx-col w-full xl:w-1/4 lg:w-1/4 md:w-1/4 sm:w-1/4">
                    <label class="vs-input--label">{{ $t('menuOrganization.branch') }}</label>
                    <v-select class="" v-model="selectedOrganizationBranch" :clearable="false"
                              :options="organizationBranchOptions">
                        <span slot="no-options">{{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                </div>
                <div style="display:inline-block" class="vx-col w-full xl:w-1/4 lg:w-1/4 md:w-1/4 sm:w-1/4">
                    <label class="vs-input--label">{{ $t('button.employee') }}</label>
                    <v-select class="" v-model="selectedEmployee" :clearable="false" :options="employeeOptions">
                        <span slot="no-options">{{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                </div>
                <div style="display:inline-block" class="vx-col w-full xl:w-1/4 lg:w-1/4 md:w-1/4 sm:w-1/4">
                    <label class="vs-input--label">{{ $t('menuOrganization.status') }}</label>
                    <v-select class="" v-model="leaveStatusModel" :clearable="false" :options="leaveStatusOptions">
                        <span slot="no-options">{{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                </div>
                <div style="display: inline-block" class="vx-col w-full xl:w-1/4 lg:w-1/4 md:w-1/4 sm:w-1/4">
                    <label class="vs-input--label">{{ $t('menuEvent.time') }}</label>
                    <div class="flex-grow w-full">
                        <date-range-picker
                            ref="picker" class="w-full"
                            :locale-data="{format: 'dd/mm/yyyy' }"
                            :opens="'left'"
                            @update="dateRangePicker"
                            v-model="dateRange">
                        </date-range-picker>
                    </div>
                </div>
            </div>
            <div class="mt-4 vx-row">
                <div class="vx-col md:w-1/2 button-create w-full flex" style="display: inline-block">
                    <vs-button
                        v-if="isPermission()"
                        @click="addLeave"
                        color="primary"
                        icon-pack="feather"
                        icon="icon-plus">
                        {{ $t('updateInout.create') }}
                    </vs-button>
                    <vs-button iconPack="feather" icon="icon-download" @click="generateReport" class="ml-5">
                        {{ $t('updateInout.export') }}
                    </vs-button>
                </div>
                <div class="vx-col md:w-1/4 button-create w-full" style="display: inline-block">
                    <label v-show="true" class="vs-input--label"></label>
                    <vs-button
                        class="float-right"
                        @click="loadLeave"
                        color="primary"
                        icon-pack="feather"
                        icon="icon-search">
                        {{ $t('timeKeeping.filter') }}
                    </vs-button>
                </div>
                <div class="vx-col md:w-1/4 w-full">
                    <vs-input class="sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                              v-model="searchQuery"
                              @input="updateSearchQuery" :placeholder="$t('button.search')"/>
                </div>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="leaveData"
                         :animateRows="true"
                         :localeText=" {noRowsToShow: this.$t('menuCustomer.noRowsToShow')}"
                         @grid-ready="onGridReady"
                         :pagination="true"
                         paginationPageSize="50"
                         @pagination-changed="onPaginationChanged"
                         :autoSizeStrategy="autoSizeStrategy"
                         tooltipShowDelay="0"
                         tooltipHideDelay="5000"
                         :tooltipMouseTrack="true">
            </ag-grid-vue>

            <div class="vx-row mt-8" v-if="totalElements > 0">
                <div style="min-width:200px" class="vx-col md:w-1/2 w-full">
                    <span class="content-page font-bold">Hiển thị: </span>
                    <span class="text-page">
                        {{ countElementPage > totalElements ? totalElements : countElementPage }} / {{ totalElements }}
                    </span>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <vs-pagination
                        :total="totalPages"
                        v-model="currentPage"
                        @change="loadPage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActions from "./cell-renderer/CellRendererActions.vue"
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import DateRangePicker from '../../../components/vue2-daterange-picker/components/DateRangePicker.vue'
import CellRendererStatus from "./cell-renderer/CellRendererStatus"
import CellRendererLeaveType from "./cell-renderer/CellRendererLeaveType";
import authConfig from '@/../auth_config.json'
import {isRouter} from "../../../store/permission"
import {constRouter} from "../../../store/constant"

export default {
    components: {
        AgGridVue,
        vSelect,
        CellRendererActions,
        Datepicker,
        DateRangePicker,
        CellRendererStatus,
        CellRendererLeaveType,
    },
    data() {
        return {
            listEmployeeIds: [],
            //isInitComplete: false,
            searchQuery: "",
            // AgGrid
            gridApi: null,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'STT',
                    field: 'stt',
                    minWidth: 100,
                },
                {
                    headerName: this.$t('menuOrganization.employeeCode'),
                    field: 'employeeCode',
                    minWidth: 150,
                    suppressSizeToFit: true,
                    tooltipField: 'employeeCode',
                },
                {
                    headerName: this.$t('menuOrganization.employeeName'),
                    field: 'fullName',
                    minWidth: 180,
                    tooltipField: 'fullName',
                },
                {
                    headerName: this.$t('menuOrganization.displayLeaveDate'),
                    field: 'displayLeaveDate',
                    minWidth: 180,
                    tooltipField: 'displayLeaveDate',
                },
                {
                    headerName: this.$t('menuOrganization.displayLeaveTime'),
                    field: 'displayLeaveTime',
                    minWidth: 120,
                    tooltipField: 'displayLeaveTime',
                },
                {
                    headerName: this.$t('menuOrganization.status'),
                    field: 'displayStatus',
                    cellRenderer: 'CellRendererStatus',
                    minWidth: 120,
                },
                {
                    headerName: this.$t('textErr.reason'),
                    field: 'reason',
                    minWidth: 200,
                    tooltipField: 'reason',
                },
                {
                    headerName: this.$t('menuOrganization.leaveType'),
                    field: 'leaveType',
                    cellRenderer: 'CellRendererLeaveType',
                    minWidth: 180,
                },
                {
                    headerName: this.$t('menuOrganization.createdDate'),
                    field: 'createdDateStr',
                    minWidth: 200,
                },
                {
                    headerName: this.$t('menuOrganization.modifiedDate'),
                    field: 'modifiedDateStr',
                    minWidth: 200,
                },
                {
                    headerName: this.$t('menuOrganization.approveEmployeeFullName'),
                    field: 'approveEmployeeFullName',
                    minWidth: 200,
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    minWidth: 170,
                    cellRenderer: 'CellRendererActions',
                    suppressSizeToFit: true,
                    pinned: 'right'
                },
            ],
            dateRange: {
                startDate: new Date(),
                endDate: (() => {
                    let date = new Date();
                    date.setDate(date.getDate() + 6);
                    date.setHours(0, 0, 0);
                    return date
                })()
            },
            leaveData: [],
            employeeOptions: [
                {value: null, label: this.$t('menuOrganization.all')}
            ],
            leaveStatusOptions: [
                {value: null, label: this.$t('menuOrganization.all')},
                {value: 0, label: 'Chờ'},
                {value: 1, label: 'Đã duyệt'},
                {value: 2, label: 'Từ chối'},
                {value: 3, label: 'Hủy bỏ'}
            ],
            organizationBranchOptions: [],
            selectedOrganizationBranchValue: null,
            selectedEmployeeValue: null,
            selectedStatus: null,
            status: null,
            fromDate: moment().format("YYYY/MM/DD"),
            toDate: moment().format("YYYY/MM/DD"),
            countElementPage: 0,
            totalElements: 0,
            tooltipShowDelay: null,
            tooltipHideDelay: null,
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            totalPages: 0,
            currentPage: 1,
        }
    },
    created() {
        this.tooltipShowDelay = 0;
        this.tooltipHideDelay = 2000;
        this.initScreen()
    },
    watch: {
        '$store.state.isUpdateLeave'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('UPDATE_LEAVE', false);
            }
        }
    },
    computed: {
        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.selectedOrganizationBranchValue),
                    value: this.selectedOrganizationBranchValue
                }
            },
            set(obj) {
                this.selectedOrganizationBranchValue = obj.value
                this.loadEmployee()
            }
        },
        selectedEmployee: {
            get() {
                return {
                    label: this.employeeString(this.selectedEmployeeValue),
                    value: this.selectedEmployeeValue
                }
            },
            set(obj) {
                this.selectedEmployeeValue = obj.value
            }
        },
        leaveStatusModel: {
            get() {
                return {
                    label: this.leaveStatusOptions.find(x => x.value == this.status).label,
                    value: this.status
                }
            },
            set(obj) {
                this.status = obj.value;
            }
        },
    },
    methods: {
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
        },
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val)
        },
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value == id);
            return (organizationBranch && organizationBranch.label) || this.$t('menuOrganization.null');
        },
        employeeString(id) {
            let employee = this.employeeOptions.find(x => x.value == id);
            return (employee && employee.label) || this.$t('menuOrganization.null');
        },
        loadEmployee() {
            if (!this.selectedOrganizationBranchValue) return;

            this.$vs.loading();
            this.$crm.post('/employee/find-by-organization-branch/' + this.selectedOrganizationBranchValue).then((response) => {
                this.employeeData = response.data;
                this.listEmployeeIds = response.data.map(el => el.employeeId);
                this.employeeOptions = response.data.map(item => {
                    return {
                        value: item.employeeId,
                        label: item.employeeCode + "_" + item.fullName,
                        ...item
                    }
                });
                this.employeeOptions.unshift({value: null, label: this.$t('menuOrganization.all')})
                this.$vs.loading.close();
                this.loadLeave()

                /*if (!this.isInitComplete) {
                  this.loadLeave()
                  this.isInitComplete = true
                }*/
            }).catch((err) => {
                this.$vs.loading.close();
                //this.isInitComplete = true;
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        addLeave() {
            this.$router.push(`/user/assign-leave?branch_id=${this.selectedOrganizationBranchValue}`).catch(() => {
            });
        },
        onGridReady(params) {
            this.gridApi = params.api;
        },
        initScreen() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
            if (branchList.length === 0) {
                return this.$vs.notify({
                    text: 'Hiện tại không tồn tại chi nhánh nào',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.organizationBranchOptions = branchList.filter(el => el.organizationBranchType !== 3).map(item => {
                return {value: item.id, label: item.organizationBranchName}
            });
            let branchId = this.$route.query.branch_id;
            let index = 0;
            if (branchId) {
                index = this.organizationBranchOptions.findIndex(item => item.value == branchId)
            }
            this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];

        },
        isPermission() {
            return isRouter(this, constRouter.leave_add);
        },
        loadLeave() {
            if (!this.selectedOrganizationBranchValue) return;
            let condition = {
                organizationBranchId: this.selectedOrganizationBranchValue,
                employeeId: this.selectedEmployeeValue,
                status: this.status,
                fromDate: moment(this.dateRange.startDate).set({hour: 0, minute: 0, second: 0, millisecond: 0}),
                toDate: moment(this.dateRange.endDate).set({hour: 23, minute: 59, second: 59, millisecond: 0})
            }
            if (!this.selectedEmployeeValue) condition.employeeIds = this.listEmployeeIds;
            this.$vs.loading();
            this.$crm.post('/leave/find', condition).then((response) => {
                this.leaveData = response.data.map(item => {
                    item.stt = response.data.indexOf(item) + 1;
                    item.displayLeaveDate = moment(item.fromDate).format("DD/MM") + " - " + moment(item.toDate).format("DD/MM");
                    item.displayLeaveTime = item.duration === 0 ? 'Cả ngày' : '';
                    if (item.duration !== 0) {

                    }
                    item.createdDateStr = moment(item.createdDate).format('HH:mm:ss DD/MM/YYYY')
                    item.modifiedDateStr = moment(item.modifiedDate).format('HH:mm:ss DD/MM/YYYY')
                    if (item.status === 0) item.approveEmployeeFullName = null;
                    let employee = this.employeeOptions.find(employee => employee.employeeId === item.employeeId);
                    let mergeData = {...item, ...employee}
                    mergeData.id = item.id;
                    return mergeData;
                });
                this.$vs.loading.close();
                this.countElementPage = this.currentPage * 50;
                this.totalElements = this.leaveData.length;
                this.currentPage = 1;
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        generateReport() {
            this.$vs.loading()
            let data = {
                organizationBranchId: this.selectedOrganizationBranchValue,
                employeeId: this.selectedEmployeeValue,
                status: this.status,
                fromDate: moment(this.dateRange.startDate).set({hour: 0, minute: 0, second: 0, millisecond: 0}),
                toDate: moment(this.dateRange.endDate).set({hour: 23, minute: 59, second: 59, millisecond: 0})
            }

            this.$crm.post('/leave/export', data).then(res => {
                window.open(authConfig.crmDomain + "file/" + res.data.fileName + "?access_token=" + localStorage.getItem("access_token"), "_blank");
                this.$vs.loading.close()
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        onPaginationChanged() {
            if (this.gridApi) {
                this.totalPages = this.gridApi.paginationGetTotalPages();
            }
        },

        loadPage: function (currentPage) {
            if (this.gridApi) this.gridApi.paginationGoToPage(currentPage - 1)
        },
    },
}
</script>

<style scoped>
.md\:w-1\/5 {
    width: 23.5% !important;
}

</style>
<style lang="scss">
.time-button {
    @media screen and (max-width: 1350px) {
        margin-top: 0.5rem;
    }
    @media screen and (max-width: 1200px) {
        margin-top: 0;
    }
}

.custom-tooltip {
    width: 150px;
    padding: 5px;
    color: rgba(var(--vs-primary), 1);
    background-color: #5577cc;
}

.custom-tooltip p {
    margin: 5px;
    white-space: nowrap;
}

.custom-tooltip p:first-of-type {
    font-weight: bold;
}

.ag-paging-panel {
    display: none;
}
</style>
